import {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {fetchPositionList} from 'web/redux/actions/PositionActions';

export const usePositionListModalControl = () => {
  const dispatch = useDispatch();

  const [positionList, setPositionList] = useState([]);
  const [needPositionListLoad, setNeedPositionListLoad] = useState(false);

  const positionListModalRef = useRef(null);

  useEffect(() => {
    if (positionListModalRef.current) {
      positionListModalRef.current = new bootstrap.Modal(
        positionListModalRef.current,
      );
    }
  }, [positionListModalRef]);

  const togglePositionListModal = (isShow) => {
    if (positionListModalRef) {
      if (isShow) {
        setNeedPositionListLoad(true);
        positionListModalRef.current.show();
      } else {
        setNeedPositionListLoad(false);
        positionListModalRef.current.hide();
      }
    }
  };

  const getPositionList = (openModal = false) => {
    dispatch(fetchPositionList({}))
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode) {
          const positionList = res.payload.result;
          setPositionList(positionList);
          if (openModal) {
            togglePositionListModal(true);
            setNeedSearchLoad((prev) => !prev);
          }
        } else {
          console.error('fetchPositionList error', res);
        }
      })
      .catch((err) => {
        console.error('fetchPositionList error', err);
      });
  };

  return {
    positionList,
    needPositionListLoad,
    positionListModalRef,
    setNeedPositionListLoad,
    togglePositionListModal,
    getPositionList,
  };
};
